import {
  GET_ZOHO_ACCESS,
  GET_ZOHO_ACCESS_SUCCESS,
  GET_ZOHO_ACCESS_FAILED,
  GET_ZOHO_COUNT,
  GET_ZOHO_COUNT_SUCCESS,
  GET_ZOHO_COUNT_FAILED,
  EXPORT_ZOHO_PROCESS,
  EXPORT_ZOHO_PROCESS_SUCCESS,
  EXPORT_ZOHO_PROCESS_FAILED,
  GET_EXPORT_ZOHO_DATA,
  GET_EXPORT_ZOHO_DATA_SUCCESS,
  GET_EXPORT_ZOHO_DATA_FAILED,
  GET_LOGS_ZOHO_DATA,
  GET_LOGS_ZOHO_DATA_SUCCESS,
  GET_LOGS_ZOHO_DATA_FAILED,
  LOGOUT_ZOHO,
  LOGOUT_ZOHO_SUCCESS,
  LOGOUT_ZOHO_FALIED,
} from "./actionTypes";

export const getZohoAccess = (data) => {
  return {
    type: GET_ZOHO_ACCESS,
    payload: data,
  };
};

export const getZohoAccessSuccess = (data) => {
  return {
    type: GET_ZOHO_ACCESS_SUCCESS,
    payload: data,
  };
};

export const getZohoAccessFailed = (error) => {
  return {
    type: GET_ZOHO_ACCESS_FAILED,
    payload: error,
  };
};

export const getZohoCount = (data) => {
  return {
    type: GET_ZOHO_COUNT,
    payload: data,
  };
};

export const getZohoCountSuccess = (data) => {
  return {
    type: GET_ZOHO_COUNT_SUCCESS,
    payload: data,
  };
};

export const getZohoCountFailed = (error) => {
  return {
    type: GET_ZOHO_COUNT_FAILED,
    payload: error,
  };
};

export const exportZohoProcess = (data) => {
  return {
    type: EXPORT_ZOHO_PROCESS,
    payload: data,
  };
};

export const exportZohoProcessSuccess = (data) => {
  return {
    type: EXPORT_ZOHO_PROCESS_SUCCESS,
    payload: data,
  };
};

export const exportZohoProcessFailed = (error) => {
  return {
    type: EXPORT_ZOHO_PROCESS_FAILED,
    payload: error,
  };
};

export const getExportData = (data) => {
  return {
    type: GET_EXPORT_ZOHO_DATA,
    payload: data,
  };
};

export const getExportDataSuccess = (data) => {
  return {
    type: GET_EXPORT_ZOHO_DATA_SUCCESS,
    payload: data,
  };
};

export const getExportDataFailed = (error) => {
  return {
    type: GET_EXPORT_ZOHO_DATA_FAILED,
    payload: error,
  };
};

export const getLogsData = (data) => {
  return {
    type: GET_LOGS_ZOHO_DATA,
    payload: data,
  };
};

export const getLogsDataSuccess = (data) => {
  return {
    type: GET_LOGS_ZOHO_DATA_SUCCESS,
    payload: data,
  };
};

export const getLogsDataFailed = (error) => {
  return {
    type: GET_LOGS_ZOHO_DATA_FAILED,
    payload: error,
  };
};

export const logoutZoho = (data) => {
  return {
    type: LOGOUT_ZOHO,
    payload: data,
  };
};

export const logoutZohoSuccess = (data) => {
  return {
    type: LOGOUT_ZOHO_SUCCESS,
    payload: data,
  };
};

export const logoutZohoFailed = (error) => {
  return {
    type: LOGOUT_ZOHO_FALIED,
    payload: error,
  };
};
